(function () {
  if (window.__ggInit) return;
  window.__ggInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* One-time reveal animations */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-gg-reveal]:not(.is-revealed)');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Variant choice: live price + availability */
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-gg-variant]');
    if (!select) return;
    var card = select.closest('[data-gg-card]');
    var opt = select.options[select.selectedIndex];
    var price = card.querySelector('[data-gg-price]');
    var btn = card.querySelector('[data-gg-add]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    if (btn) {
      var available = opt.dataset.available === 'true';
      btn.disabled = !available;
      btn.removeAttribute('aria-disabled');
      var label = btn.querySelector('span');
      if (label) {
        label.classList.remove('hidden');
        label.textContent = available ? btn.dataset.addLabel : btn.dataset.soldLabel;
      }
      var sold = btn.querySelector('.sold-out-message');
      if (sold) sold.classList.add('hidden');
    }
  });

  /* Sticky nav: sit below the header when it is showing */
  function headerBottom() {
    var header = document.querySelector('.section-header, .shopify-section-group-header-group.section-header, sticky-header');
    if (!header) return 0;
    var b = header.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }
  function initNav() {
    var host = document.querySelector('[data-gg-nav-host]');
    if (!host) return;
    var wrapper = host.closest('.shopify-section') || host;
    wrapper.classList.add('gg-nav-host');
    var ticking = false;
    function update() {
      ticking = false;
      var top = Math.round(headerBottom());
      wrapper.style.setProperty('--gg-nav-top', top + 'px');
      document.documentElement.style.setProperty('--gg-jump-offset', (top + wrapper.offsetHeight + 16) + 'px');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();

    var links = host.querySelectorAll('a[href^="#"]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        jumpTo(target);
      });
    });
    if ('IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (l) { map[l.getAttribute('href').slice(1)] = l; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var l = map[en.target.id];
          if (l && en.isIntersecting) {
            links.forEach(function (x) { x.classList.remove('is-active'); x.removeAttribute('aria-current'); });
            l.classList.add('is-active');
            l.setAttribute('aria-current', 'true');
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      Object.keys(map).forEach(function (id) { var t = document.getElementById(id); if (t) io.observe(t); });
    }
  }

  function jumpTo(target) {
    var nav = document.querySelector('.gg-nav-host');
    var navH = nav ? nav.offsetHeight : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - navH - 16;
    if (y < window.pageYOffset) y -= headerBottom() || 80;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  /* Hero / other in-page buttons */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-gg-jump]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').split('#')[1];
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    if (target.matches('[data-gg-finder]')) openFinder(target);
    jumpTo(target);
  });

  /* Gift finder */
  function openFinder(finder) {
    var toggle = finder.querySelector('[data-gg-finder-toggle]');
    var body = finder.querySelector('[data-gg-finder-body]');
    if (!body || !body.hidden) return;
    body.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
  function runFinder(finder) {
    var love = finder.querySelector('input[name$="-love"]:checked');
    var budget = finder.querySelector('input[name$="-budget"]:checked');
    if (!love || !budget) return;
    var results = finder.querySelector('[data-gg-results]');
    var empty = finder.querySelector('[data-gg-empty]');
    var picks = Array.prototype.slice.call(finder.querySelectorAll('[data-gg-pick]'));
    var max = parseInt(budget.value, 10);
    var want = love.value;
    var shown = 0;
    picks.forEach(function (p) {
      p.hidden = true;
      p.classList.remove('gg-pick--lead');
      var badge = p.querySelector('.gg-pick__badge');
      if (badge) badge.hidden = true;
      var tags = (p.dataset.tags || '').split(' ');
      var price = parseInt(p.dataset.price, 10);
      var ok = p.dataset.available === 'true' && tags.indexOf(want) > -1 && (max === 0 || price <= max * 100);
      if (ok && shown < 3) {
        p.hidden = false;
        if (shown === 0) { p.classList.add('gg-pick--lead'); if (badge) badge.hidden = false; }
        shown++;
      }
    });
    results.hidden = shown === 0;
    empty.hidden = shown !== 0;
    finder.querySelector('.gg-finder__panel').classList.remove('is-open');
    requestAnimationFrame(function () { finder.querySelector('.gg-finder__panel').classList.add('is-open'); });
    var live = finder.querySelector('[data-gg-live]');
    if (live) live.textContent = shown === 0 ? empty.textContent.trim() : (shown + ' ' + live.dataset.found);
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-gg-finder-toggle]');
    if (toggle) {
      var finder = toggle.closest('[data-gg-finder]');
      var body = finder.querySelector('[data-gg-finder-body]');
      var open = body.hidden;
      body.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) { var first = body.querySelector('input'); if (first) first.focus(); }
      return;
    }
    var reset = e.target.closest && e.target.closest('[data-gg-reset]');
    if (reset) {
      var f = reset.closest('[data-gg-finder]');
      f.querySelectorAll('input[type=radio]').forEach(function (r) { r.checked = false; });
      f.querySelector('[data-gg-results]').hidden = true;
      f.querySelector('[data-gg-empty]').hidden = true;
      var firstInput = f.querySelector('input[type=radio]');
      if (firstInput) firstInput.focus();
    }
  });
  document.addEventListener('change', function (e) {
    var finder = e.target.closest && e.target.closest('[data-gg-finder]');
    if (finder && e.target.type === 'radio') runFinder(finder);
  });

  function init() { initReveal(document); initNav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initNav(); });
})();
